import React, { useEffect, useState } from "react";
import { Badge, Button, Calendar, Modal, Tooltip } from "antd";
import { FaCalendarAlt } from "react-icons/fa";
import RPMService from "../../Services/RPMService";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const CalendarView = () => {
  const { patientData } = useSelector((state) => state.auth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [rpmCalenderActivity, setRpmCalenderActivity] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth() + 1);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (!patientData?.patientId) return;

    const fromDate = dayjs(new Date(selectedYear, selectedMonth - 1, 1)).format(
      "MM/DD/YYYY"
    );
    const toDate = dayjs(new Date(selectedYear, selectedMonth, 0)).format(
      "MM/DD/YYYY"
    );

    const payload = {
      patientId: patientData.patientId,
      rpmApplicable: "Y",
      fromDate,
      toDate,
    };

    fetchRpmPatCalenderActivity(payload);
  }, [patientData, selectedYear, selectedMonth]);

  const fetchRpmPatCalenderActivity = async (payload) => {
    try {
      const response = await RPMService.rpmCalenderActivity(payload);
      setRpmCalenderActivity(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const dateCellRender = (value) => {
    const formatted = value.format("YYYY-MM-DD");
    const matchedEntry = rpmCalenderActivity.find(
      (item) => item.date === formatted
    );

    if (!matchedEntry) return null;

    const tags = getEventTags(matchedEntry);

    return (
      <ul className="events">
        {tags.map((tag, index) => (
          <li key={index}>
            <Tooltip title={tag.type}>
              <Badge color={tag.color} text={tag.type} />
            </Tooltip>
          </li>
        ))}
      </ul>
    );
  };

  const getEventTags = (entry) => {
    const tags = [];

    if (entry.vitalsEntered === "Y") {
      tags.push({ type: "Vitals", color: "green" });
    }
    if (entry.medicationEntered === "Y") {
      tags.push({ type: "Medication", color: "blue" });
    }
    if (entry.taskEntered === "Y") {
      tags.push({ type: "Task", color: "orange" });
    }

    return tags;
  };

  const handlePanelChange = (value, mode) => {
    const newMonth = value.month() + 1;
    const newYear = value.year();

    if (newMonth !== selectedMonth || newYear !== selectedYear) {
      setSelectedMonth(newMonth);
      setSelectedYear(newYear);
    }
  };

  return (
    <>
      <span title="Calendar View" onClick={showModal}>
        <FaCalendarAlt className="text-[#00a0c8]" size={16} role="button" />
      </span>

      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1500}
        footer={[]}
        style={{ top: 20 }}
      >
        <Calendar
          dateCellRender={dateCellRender}
          onPanelChange={handlePanelChange}
        />
      </Modal>
    </>
  );
};

export default CalendarView;
